<template lang="pug">
  .container-fluid(v-show="productList.length > 0")
    .caption 最近チェックした商品
    .slider
      .item(v-for='product in productList')
        a(v-bind:href='product.link')
          .product-img #[img(v-bind:src='product.img')]
          .specs-box.row(v-show="product.spec.power")
            .col-6
              .spec {{product.spec.power}}
            .col-6
              .spec {{product.spec.span}}
          .specs-box.row(v-show="product.spec.power")
            .col-6
              .spec {{product.spec.dia}}
            .col-6
              .spec {{product.spec.bc}}
          .pt15(v-show="!product.spec.power")
          .maker-name {{product.makerName}}
          .color-name {{product.colorName}}
          .price ¥{{product.price}}
</template>

<script>
import axios from 'axios'
import config from '../../config/Config'

export default {
  name: 'CheckedProducts',
  /**
   * data
   */
  data () {
    return {
      checkedProductList: []
    }
  },
  mixins: [config],
  computed: {
    /**
     * productList
     * @return []
     */
    productList () {
      return this.checkedProductList
    }
  },
  /**
   * mounted
   */
  mounted () {
    let url = this.BASE_URL + 'rest/customer/checked/products'
    if (window.location.pathname.indexOf('/i/') >= 0) {
      url = this.BASE_URL + 'rest/customer/checked/products/' + window.location.pathname.substring(3)
    }
    axios.get(url)
      .then(response => {
        if (response.status === 200) {
          if (response.data.success) {
            response.data.checked_products.forEach(checkedProduct => {
              this.checkedProductList.push({
                productId: checkedProduct.product_id,
                // TODO 定数化
                img: 'http://d28qg0el9tv5wv.cloudfront.net/data/img/items/' + checkedProduct.product_code + '/' + checkedProduct.sub_image1,
                spec: {
                  power: checkedProduct.spec_power.replace(',度', '・'),
                  span: checkedProduct.spec_span,
                  dia: checkedProduct.spec_dia,
                  bc: checkedProduct.spec_bc
                },
                makerName: checkedProduct.maker.name,
                colorName: checkedProduct.name_color,
                price: String(checkedProduct.price02).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'),
                link: this.BASE_URL + 'i/' + checkedProduct.product_id
              })
            })
          }
        }
      }).catch(reason => {
      })
  }

}
</script>

<style scoped lang="scss">
@import '../../../assets/scss/bootstrap/bootstrap.scss';

.caption {
  padding: 14px 11px 10px 11px;
  font-size: 12px;
  color: #333;
  font-weight: bold;
  border-bottom: 1px solid #ccc;
  text-align: center;
}
.slider {
  overflow-x: auto;
  overflow-y: hidden;
  padding-left: 5px;
  margin-bottom: 8px;
}
.item {
  padding: 11px 0px 0px 6px;
  display: table-cell;
  padding-right: 1px;
}
.item:last-child {
  padding-right: 0;
}
.item a {
  color: #333;
  text-decoration: none;
}
.product-img img{
  width: 128px;
  margin-bottom: 5px;
}
.specs-box .spec {
  height: 18px;
  font-size: 8px;
  line-height: 18px;
  text-align: center;
  background: #eee;
  margin: 1px;
  border-radius: 2px;
}
.maker-name {
  padding: 0;
  color: #000;
  font-weight: normal;
  width: 96px;
  height: 22px;
  display: block;
  overflow: hidden;
  clear: both;
  border-bottom: none;
  font-size: 8px;
  font-weight: bold;
  letter-spacing: -0.1em;
  line-height: 2.6em;
}
.color-name {
  padding: 0;
  width: 96px;
  height: 16px;
  display: block;
  overflow: hidden;
  font-size: 8px;
  font-weight: normal;
  letter-spacing: -0.05em;
}
.price {
  font-size: 12px;
  color: #f15e4b;
  text-align: right;
  font-weight: bold;
}

</style>



// WEBPACK FOOTER //
// src/components/sp/common/CheckedProducts.vue